<template>
    <transition name="show">
        <div v-show="show" class="desk-header d-flex align-center px12">
            <header-apps />
            <header-separator line />
            <header-brand />
            <header-separator />
            <header-tabs class="flex-grow-1" />
            <header-separator />
            <!-- <header-message /> -->
            <header-separator />
            <header-settings />
            <header-separator />
            <header-user />
        </div>
    </transition>
</template>

<script>
import HeaderApps from '@/components/desk-header/header-apps';
import HeaderBrand from '@/components/desk-header/header-brand';
import HeaderSettings from '@/components/desk-header/header-settings';
import HeaderUser from '@/components/desk-header/header-user';
// import HeaderMessage from '@/components/desk-header/header-message';
import HeaderTabs from '@/components/desk-header/header-tabs.vue';
import HeaderSeparator from '@/components/desk-header/header-separator';
export default {
    name: 'DeskHeader',
    components: {
        HeaderSeparator,
        // HeaderMessage,
        HeaderUser,
        HeaderSettings,
        HeaderBrand,
        HeaderApps,
        HeaderTabs
    },
    data() {
        return {
            show: false
        };
    },
    mounted() {
        this.show = true;
    }
};
</script>

<style lang="scss" scoped>
@import '../../styles/var';

.desk-header {
    height: $desk-header-height;
    background-color: $desk-background-color;
    color: #fff;
}

.show-enter-active,
.show-leave-active {
    transition: all 456ms ease-in-out;
}

.show-enter,
.show-leave-to {
    transform: translateY(-100%);
    opacity: 0;
}
</style>
